
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { useSegmentData } from "@/hooks/use-segment-data";
import { Card, CardContent } from "@/components/ui/card";

interface SegmentSelectorProps {
  selectedSegment: string | null;
  onSegmentSelect: (segment: string) => void;
}

export function SegmentSelector({ selectedSegment, onSegmentSelect }: SegmentSelectorProps) {
  const { segments } = useSegmentData();

  return (
    <Card className="w-full max-w-md mx-auto shadow-sm transition-all duration-300 hover:shadow-md">
      <CardContent className="p-8">
        <div className="space-y-6">
          <h3 className="text-xl font-semibold text-center text-drcash-maastricht-blue mb-2">
            Selecione seu segmento
          </h3>
          <Select value={selectedSegment || ""} onValueChange={onSegmentSelect}>
            <SelectTrigger className="w-full text-base py-6 border-gray-200 focus:ring-drcash-caribbean-green focus:border-drcash-caribbean-green">
              <SelectValue placeholder="Escolha seu segmento" />
            </SelectTrigger>
            <SelectContent>
              {segments.map((segment) => (
                <SelectItem key={segment.name} value={segment.name}>
                  <div className="flex items-center gap-2 py-1">
                    {segment.icon}
                    <span>{segment.name}</span>
                  </div>
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
      </CardContent>
    </Card>
  );
}
